import React, { Component } from 'react';
import { Modal, message, Carousel } from '@cloud/atom-ui';
import { PlusOutlined } from '@cloud/atom-ui-icons/PlusOutlined';
import { LeftOutlined } from '@cloud/atom-ui-icons/LeftOutlined'
import { RightOutlined } from '@cloud/atom-ui-icons/RightOutlined'
import './file.less'
import {urlDomainDeal} from "@src/utils/common";


export default class PicturesWall extends Component {
  constructor(props) {
    super(props)
    this.chooseIndex = null;
  }

  state = {
    files: [],
    visible: false,
    visibleImg: false,
    visibleVideo: false,
    isOpen: false,
    showModal: false,
    imgSrc: '',
    index: 0,
    videoSrc: '',
    imgPreviewList: [],
    imgList1: [{ img: require('@src/assets/mm.png') }, require('@src/assets/11.png'), require('@src/assets/12.png'), require('@src/assets/22.png')],
    imgList: this.props.item.value
  }
  timeOutId = null;

  toggleContainer = React.createRef();

  getBase64 = (img) => {
    const reader = new FileReader();
    reader.readAsDataURL(img);
    reader.onload = () => {
      if (this.state.files.length >= 10) {
        message.error('图片数量最多!');
        return;
      }
      this.setState((state, props) => ({ files: [...state.files, { imgUrl: reader.result }] }), () => {
      });

      this.setState((state, props) => ({ imgList: [...state.imgList, reader.result] }))

    }

  }
  beforeUpload = (file) => {
    let isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    //判断图片类型
    if (!isJpgOrPng) {
      message.error('只能上传jpg和png的文件类型');
      return isJpgOrPng = Promise.reject();
    }
    let isLt2M = file.size / 1024 < 10000000;
    //判断图片大小
    if (!isLt2M) {
      message.error('图片不能超过100KB');
      return isLt2M = Promise.reject();
    }
    //判断图片尺寸
    const specsSize = new Promise((resolve, reject) => {
      let IMG = new Image();
      let _URL = window.URL || window.webkitURL;
      IMG.src = _URL.createObjectURL(file)
      let valid;
      IMG.onload = () => {
        valid = true;
        valid ? resolve() : reject();
      }
    }).then(() => file, () => {
      message.error('图片尺寸应该是 984 * 2000');
      return Promise.reject();
    })
    // 判断图片类型，大小，尺寸
    return isJpgOrPng && isLt2M && specsSize;

  }
  pen1 = () => {
    this.textInput.click();
  }
  // 上传
  changePic = async (event) => {
    event.persist();
    let files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      //上传前判断图片类型，大小，尺寸
      let imgs = await this.beforeUpload(files[i]);
      this.getBase64(imgs);
    }
  }

  deleteImg = (index) => {
    let files = this.state.imgList;
    files.splice(index, 1);
    this.setState({
      imgList: [...files]
    })
  }


  preview = () => {
    this.setState(state => ({
      isOpen: !state.isOpen
    }));
  }

  bigPic = (type) => {
    const length = this.state.imgList.length;
    if (type === 0) { // 向左,减1
      this.setState((state, props) => ({
        index: state.index - 1
      }))
    } else if (type === 1) { // 向右,加1
      this.setState((state, props) => ({
        index: state.index + 1
      }))
    }
  }


  onBlurHandler = (event) => {
    event.persist();
    if (this.state.isOpen && !this.toggleContainer.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  }

  onFocusHandler = () => {
    clearTimeout(this.timeOutId);
  }
  handlePre = () => {
    this.chooseIndex.slick.slickPrev();
  }

  handleNext = () => {
    this.chooseIndex.slick.slickNext();
  }

  disPlayImg = (indexPic, itemEach) => {
    this.setState({
      visible: true
    })
    if (itemEach.type === 'video') {
      this.setState({
        visibleVideo: true,
        videoSrc: itemEach.url
      })
    } else if (itemEach.type === 'img') {
      let videosList = [];
      let imgPreview = []
      let count = 0, defaultIndex = 0, defaultCount = 0;
      this.state.imgList.forEach((item, index) => {
        if (item.type === 'video') {
          videosList.push(item);
          count++;
        } else {
          if (indexPic === index) {
            defaultIndex = index;
            defaultCount = count;
          }
          imgPreview.push(item);
        }
      })
      this.setState({
        imgPreviewList: imgPreview,
        visibleImg: true
      })

      setTimeout(() => {
        this.chooseIndex.slick.slickGoTo(defaultIndex - defaultCount)
      }, 0);
    }

  }

  hideModal = () => {
    this.setState({
      visible: false,
      visibleImg: false,
      visibleVideo: false
    })
  }


  render() {
    const { files, isOpen, imgList, index, visible, videoSrc, imgPreviewList, visibleImg, visibleVideo } = this.state;
    const { item } = this.props;
    const { isEdit, value } = item;
    return (
      <>
        <div className="pic-wall">
          {
            isEdit
              ? <div className="picture-list">
                {
                  imgList.map((file, index) => {
                    return (<div className="image-list" key={index}>
                      <img src={urlDomainDeal(file)} alt="" />
                      <i onClick={() => this.deleteImg(index)}></i>
                    </div>)
                  })
                }

                {imgList.length >= 10 ? null : <div className="file-upload-select" onClick={this.pen1}>
                  <span className="file-upload" role="button">
                    <PlusOutlined />
                    <input ref={(input) => this.textInput = input} onChange={this.changePic}
                      type="file" accept="" multiple style={{ display: 'none' }} />
                    <div>上传</div>
                  </span>
                </div>}
              </div>
              : imgList.map((item, index) => item.type === 'video'
                ? <div className="video-background" onClick={() => this.disPlayImg(index, item)}>
                  <video className="avatar-img-read" src={urlDomainDeal(item.url)} key={index}></video>
                  <div className="background-img"></div>
                </div> :
                <img className="avatar-img-read" key={index}
                  src={item.url && item.url.replace("obs.cn-north-7.ulanqab.huawei.com:5443", "obs.cn-north-7.ulanqab.huawei.com")}
                  onClick={() => this.disPlayImg(index, item)} />)
          }
        </div>
        <div className="pic-wall-modal" style={{ display: isOpen ? 'block' : 'none' }} onClick={this.onBlurHandler}>
          <div className="pic-center">
            <div className="pic-show" ref={this.toggleContainer}>
              {imgList.map((item, index) => (
                <img className="item"
                  src={item && item.toString().replace("obs.cn-north-7.ulanqab.huawei.com:5443", "obs.cn-north-7.ulanqab.huawei.com")}
                  key={index} alt="" />
              ))}
            </div>
          </div>
        </div>
        {visible && <Modal
          maskClosable={false}
          title="图片"
          visible={visible}
          onCancel={this.hideModal}
          footer={null}
          width={500}
          bodyStyle={{ padding: 0 }}
        >
          {visibleImg && <div className="pic-carousel">
            <LeftOutlined onClick={this.handlePre} style={{ fontSize: '30px' }} theme="outlined" />
            <div style={{ width: '400px', height: '400px' }}>
              <Carousel dots={false} ref={el => this.chooseIndex = el}>
                {imgPreviewList.length > 0 && imgPreviewList.map((img, index) => (<div>
                  <img
                    src={img.url && img.url.replace("obs.cn-north-7.ulanqab.huawei.com:5443", "obs.cn-north-7.ulanqab.huawei.com")}
                    alt="" key={index} style={{ width: '400px', height: '400px' }} />
                </div>))}
              </Carousel>
            </div>

            <RightOutlined onClick={this.handleNext} style={{ fontSize: '30px' }} />
          </div>}
          {visibleVideo && <div className="video-display">
            <video width='500' height="500" autoPlay="autoplay" preload="true" controls
              src={videoSrc && videoSrc.replace("obs.cn-north-7.ulanqab.huawei.com:5443", "obs.cn-north-7.ulanqab.huawei.com")}>
              <source
                src={videoSrc && videoSrc.replace("obs.cn-north-7.ulanqab.huawei.com:5443", "obs.cn-north-7.ulanqab.huawei.com")}
                type="video/mp4"></source>
              <source
                src={videoSrc && videoSrc.replace("obs.cn-north-7.ulanqab.huawei.com:5443", "obs.cn-north-7.ulanqab.huawei.com")}
                type="video/webm"></source>
              <source
                src={videoSrc && videoSrc.replace("obs.cn-north-7.ulanqab.huawei.com:5443", "obs.cn-north-7.ulanqab.huawei.com")}
                type="video/ogg"></source>
            </video>
          </div>}
        </Modal>
        }
      </>
    )
  }

}

